/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Investors
 */
export interface Investors {
}

/**
 * Check if a given object implements the Investors interface.
 */
export function instanceOfInvestors(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestorsFromJSON(json: any): Investors {
    return InvestorsFromJSONTyped(json, false);
}

export function InvestorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Investors {
    return json;
}

export function InvestorsToJSON(value?: Investors | null): any {
    return value;
}

